<template>
  <div class="team-card-wrapper"
       v-if="team"
       :class="[
           selectedModel.some(({ id }) => id === team.id) && 'active',
       ]"
  >
    <div class="selected">
<!--      <b-form-checkbox size="lg" v-model="selectedModel" :value="team">-->
<!--        <span class="checkbox-label">Выбрать</span>-->
<!--      </b-form-checkbox>-->
    </div>
    <div class="content">
      <header>
        <div>
          <h4 class="allow-select" @click="$emit('editTeam', { team, result })">
            {{ serialNumber && `${ serialNumber }. ` }}{{ team?.name }}
            <img class="pen-icon" :src="PenIcon" alt="" />
          </h4>
          <span class="subtitle">{{ team?.division?.name['ru'] }}</span>
          <div v-if="entryAuthorContacts.length" class="owner-contacts">
            <span class="owner-contacts-title">Контакты владельца заявки:</span>
            <a v-for="contact in entryAuthorContacts"
               :key="`contact-${ result?.id }-${ contact.provider }`"
               class="owner-contact"
               target="_blank"
               rel="noopener noreferrer"
               :href="contact.href">[{{ contact.username }} {{ contact.provider }}]</a>
          </div>
        </div>
        <div class="right-header">
          <button class="action show-players" @click="isShowPlayers = !isShowPlayers">
            <span class="d-none d-sm-block"> {{ isShowPlayers ? 'Скрыть игроков' : 'Показать игроков' }}</span>
            <span class="d-sm-none d-block"><i class="fa fa-users fa-lg" aria-hidden="true"></i></span>
          </button>
          <button class="action show-matches" @click="isShowMatches ? isShowMatches = false : getResultMatches()">
            <span class="d-none d-sm-block">{{ isLoadingMatches ? 'Получение матчей' : isShowMatches ? 'Скрыть матчи' : 'Показать матчи' }}</span>
            <span class="d-sm-none d-block"><i class="fa fa-trophy fa-lg" aria-hidden="true"></i></span>
          </button>
          <span class="id-team">
          slot:
          <template v-if="isLoadingSaveSlot">
            <b-spinner />
          </template>
          <template v-else>
            <template v-if="!isEditSlot">
<!--              {{ slotModel v-if="isEditSlot" }}-->
              <b-form-input v-model="slotModel"
                            v-if="!isCompletedTournament"
                            @input="callSaveSlotNumber"
                            type="number"
                            size="sm" />
              <template v-else>
                {{ slotModel }}
              </template>
            </template>
<!--            <b-form-input v-model="slotModel"-->
<!--                          v-if="isEditSlot"-->
<!--                          type="number"-->
<!--                          size="sm" />-->
<!--            <img v-if="!isEditSlot" @click="isEditSlot = true" :src="PenGrayIcon" alt="" />-->
<!--            <img v-else @click="saveSlotNumber" :src="FloppyDiskGrayIcon" alt="">-->
          </template>
        </span>
        </div>
      </header>
      <div class="body">
        <div v-if="isShowPlayers" class="players-data">
          <template v-if="players.length">
            <h4>Игроки</h4>
            <table>
              <tr>
                <td>Username</td>
                <td>Nick</td>
                <td>PUBG ID</td>
              </tr>
              <tr v-for="player in players" :key="'player-' + player.id">
                <td>{{ player.user.username }}</td>
                <td>{{ getGameProfile(player).fields.nick }}</td>
                <td>{{ getGameProfile(player).fields.pubg_id }}</td>
              </tr>
            </table>
          </template>
          <div v-else class="pug">
            Игроков нет
          </div>
        </div>
        <div v-if="isShowMatches" class="matches-data">
          <h4 :class="[isShowPlayers && 'mt-4']">Матчи</h4>
          <table v-if="matches.length">
            <tr>
              <td>Название матча</td>
              <td>Убийства</td>
              <td>Place PTS</td>
              <td>Общее</td>
            </tr>
            <tr v-for="match in matches" :key="match.id">
              <td>{{ match?.match?.name || '' }}</td>
              <td>{{ match.kill_pts }}</td>
              <td>{{ match.place_pts }}</td>
              <td>{{ match.kill_pts + match.place_pts }}</td>
            </tr>
          </table>
          <div v-else class="pug">
            Матчей нет
          </div>
        </div>
      </div>
      <div class="main-data">
        <div class="activity-board">
          <div v-for="activity in activityData" :key="activity.value + activity.icon" class="activity">
            <img :src="activity.icon" alt="" />
            <span>{{ activity.value }}</span>
          </div>
        </div>
        <div v-if="!isCompletedTournament" class="actions-boards">
          <button class="action select" @click="toggleTeam">{{ selectedModel.some(({ id }) => id === team.id) ? 'Отменить выбор' : 'Выбрать' }}</button>
          <button class="action delete" v-if="!activityData.at(-1).value" @click="isShowDeleteTeamModal = !isShowDeleteTeamModal">Удалить</button>
        </div>
      </div>
      <div class="status"
           :class="`status--${ getStatusOfParticipation(result?.is_approve_game_time).variant }`"
           v-if="result?.is_approve_game_time !== null">
        <img class="status-icon" :src="getStatusOfParticipation(result?.is_approve_game_time).icon" alt=""/>
        <span class="status-text">
          {{getStatusOfParticipation(result?.is_approve_game_time).text}}
        </span>
      </div>
      <footer>
        <b-alert v-if="errorText" class="mt-4 mb-0" show variant="danger">
          {{ errorText }}
        </b-alert>
      </footer>
      <Modals v-model="isShowDeleteTeamModal" name="BasicDeleteTeamTournament" title="Удаление команды" :params="{ team, result }" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import api from "@/api/api";

import Modals from "@/components/modals/index.vue";

import GunIcon from '@/assets/icons/gun.svg'
import RankingStarIcon from '@/assets/icons/ranking-star.svg'
import GripLinesIcon from '@/assets/icons/grip-lines.svg'
import PenGrayIcon from '@/assets/icons/pen-gray.svg'
import FloppyDiskGrayIcon from '@/assets/icons/floppy-disk-gray.svg'
import PenIcon from '@/assets/icons/pen.svg'
import NotApprovedIcon from '@/assets/icons/clock.svg'
import ApprovedIcon from '@/assets/icons/check-black.svg'
import RejectedIcon from '@/assets/icons/xmark-black.svg'

import lodash from 'lodash'

export default {
  name: "TeamCard",
  props: {
    value: {
      type: Array,
      required: true,
    },
    team: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    members: {
      type: Array,
      required: true
    },
    serialNumber: {
      type: Number,
      default: 0
    }
  },
  components: {
    Modals
  },
  computed: {
    ...mapState('moduleNewTournament', ['tournament', 'selectedGroupId', 'selectedRoundId', 'selectedStageId']),
    ...mapGetters('moduleNewTournament', ['selectedStage', 'isCompletedTournament']),
    activityData() {
      return [
        {
          icon: GunIcon,
          value: this.result.group_result.result_fields.kill_pts
        },
        {
          icon: RankingStarIcon,
          value: this.result.group_result.result_fields.place_pts
        },
        {
          icon: GripLinesIcon,
          value: this.result.group_result.result_fields.kill_pts + this.result.group_result.result_fields.place_pts
        }
      ]
    },
    players() {
      return this.members
    },
    entryAuthorContacts() {
      const contacts = this.result?.entry_author?.contacts || {}
      return Object.entries(contacts)
          .filter(([, value]) => !!value)
          .map(([provider, value]) => ({
            provider,
            username: this.getContactUsername(value),
            href: this.getContactHref(provider, value)
          }))
    },
    selectedModel: {
      get() { return this.value },
      set(newValue) { this.$emit('input', newValue) }
    },
  },
  data() {
    return {
      PenIcon,
      PenGrayIcon,
      FloppyDiskGrayIcon,
      isShowPlayers: false,
      isEditSlot: false,
      isLoadingSaveSlot: false,
      isShowDeleteTeamModal: false,
      isLoadingMatches: false,
      isShowMatches: false,
      slotModel: 0,
      errorText: '',
      matches: []
    }
  },
  methods: {
    async saveSlotNumber() {
      try {
        this.errorText = ''
        this.isLoadingSaveSlot = true
        await api.tournamentGroupResult.newUpdateGroupResult(this.result.group_result.id,{
          slot_number: this.slotModel,
        })
        if (this.tournament.game.slug === 'pubg-mobile')
          await this.$store.dispatch('moduleNewTournament/getTeamsByGroup', { id: this.selectedGroupId })
        if (this.tournament.game.slug === 'mlbb')
          await this.$store.dispatch('moduleNewTournament/getGroupsWithTeamsByMLBB', { roundId: this.selectedRoundId })
        await this.$store.dispatch('moduleNewTournament/getTournament', {
          id: this.$route.params.standingId
        })
      } catch (e) {
        this.errorText = `Ошибка по сохранению номер слота: ${ e.response.data.message }`
      } finally {
        this.isLoadingSaveSlot = false
        this.isEditSlot = false
      }
    },
    async getResultMatches() {
      this.isLoadingMatches = true
      const response = (await api.tournamentGroupResult.newGrabGroupMatchesResult(this.result.group_result.id)).data;
      this.matches = response.group_result.group_match_results.map(({ result_fields, ...other }) => ({ ...other, ...result_fields }))
      this.isShowMatches = true
      this.isLoadingMatches = false
    },
    toggleTeam() {
      // const selectedTeam = this.selectedModel.find(({ id }) => id === this.team.id)
      const selectedTeamIndex = this.selectedModel.findIndex(({ id }) => id === this.team.id)
      if (selectedTeamIndex > -1) {
        this.selectedModel.splice(selectedTeamIndex, 1)
      } else {
        this.selectedModel.push({
          ...this.team,
          stage_team_id: this.result.stage_team_id
        })
      }
    },
    getContactUsername(value) {
      const contact = String(value).trim().replace(/\/+$/, '')
      if (/^https?:\/\//i.test(contact)) return contact.split('/').pop()
      return contact.replace(/^@/, '')
    },
    getContactHref(provider, value) {
      const contact = String(value).trim()
      if (/^https?:\/\//i.test(contact)) return contact
      const username = this.getContactUsername(contact)
      if (provider === 'telegram') return `https://telegram.me/${ username }`
      if (provider === 'discord') return `https://discordapp.com/users/${ username }`
      return contact
    },
    getGameProfile(player) {
      return player.user.game_profiles.find(({ game_id }) => game_id === this.tournament.game_id)
    },
    getStatusOfParticipation(status) {
      const participationStatus = {
        NOT_APPROVED: 0,
        REJECTED: 1,
        APPROVED: 2
      };
      // variant красит чип статуса: янтарный / красный / зелёный
      if(status === participationStatus.NOT_APPROVED) {return {icon: NotApprovedIcon, text: 'Не подтверждено', variant: 'warn'}}
      if(status === participationStatus.REJECTED) {return {icon: RejectedIcon, text: 'Отклонено', variant: 'danger'}}
      if(status === participationStatus.APPROVED) {return {icon: ApprovedIcon, text: 'Подтверждено', variant: 'ok'}}
      return false
    },
    callSaveSlotNumber: lodash.debounce(function () {
      this.saveSlotNumber()
    }, 2000)
  },
  watch: {
    'result': {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.slotModel = newValue?.group_result?.slot_number || 0
      }
    }
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form-tokens";

.team-card-wrapper {
  @include tf-tokens-light;

  transition: .18s;
  display: grid;
  grid-template-columns: 0 auto;

  /* выбранная команда: тонкая метка слева и акцентная рамка */
  &.active {
    grid-template-columns: 6px auto;

    .selected {
      max-width: 100vw;
      margin-right: -6px;
    }

    .content { border-color: var(--tf-primary); }
  }

  & > * { align-self: stretch; }

  .selected {
    background: var(--tf-primary);
    height: 100%;
    max-width: 0;
    overflow: hidden;
    transition: .18s;
    border-radius: 12px 0 0 12px;
    position: relative;
    z-index: 2;
  }

  .content {
    background: var(--tf-bg);
    border: 1px solid var(--tf-border-strong);
    border-radius: 12px;
    box-shadow: var(--tf-shadow-md);
    padding: 14px 16px;
    transition: border-color .18s ease, box-shadow .18s ease;
    z-index: 3;

    &:hover {
      border-color: var(--tf-primary);
      box-shadow: var(--tf-shadow-lg);
    }

    /* кнопки внутри карточки: спокойные, опасное действие — красным */
    button.action {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      height: 30px;
      padding: 0 12px;
      border: 1px solid var(--tf-border-strong);
      border-radius: 9px;
      background: var(--tf-bg);
      color: var(--tf-text);
      font-size: 12px;
      font-weight: 500;
      white-space: nowrap;
      transition: all .16s ease;

      &:hover {
        border-color: var(--tf-primary);
        background: var(--tf-primary-soft);
        color: var(--tf-primary);
      }

      &.delete {
        color: var(--tf-danger);
        border-color: var(--tf-border);

        &:hover { background: var(--tf-danger-soft); border-color: var(--tf-danger); color: var(--tf-danger); }
      }

      &.select {
        border-color: var(--tf-primary);
        color: var(--tf-primary);
        font-weight: 600;

        &:hover { background: var(--tf-primary); color: #fff; }
      }
    }

    header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;

      h4 {
        margin: 0;
        font-size: 17px;
        font-weight: 700;
        letter-spacing: -.01em;
        color: var(--tf-text-strong);
        transition: color .16s ease;

        &.allow-select {
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;

          .pen-icon {
            width: 11px;
            opacity: 0;
            transition: opacity .16s ease;
          }

          &:hover {
            color: var(--tf-primary);

            .pen-icon { opacity: 1; }
          }
        }
      }

      .subtitle {
        display: inline-flex;
        align-items: center;
        margin-top: 4px;
        padding: 2px 8px;
        border-radius: 999px;
        background: var(--tf-soft-2);
        font-size: 11px;
        font-weight: 600;
        color: var(--tf-muted);
      }

      .owner-contacts {
        margin-top: 5px;
        font-size: 11.5px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 6px;

        .owner-contacts-title { color: var(--tf-muted); }

        .owner-contact {
          color: var(--tf-primary);
          white-space: nowrap;

          &:hover { text-decoration: underline; }
        }
      }

      /* номер слота */
      .id-team {
        display: flex;
        align-items: center;
        gap: 4px;
        color: var(--tf-muted);
        font-size: 11.5px;
        white-space: nowrap;

        .spinner-border {
          width: 18px;
          height: 18px;
          margin-left: 4px;
        }

        input {
          width: 48px;
          height: 30px;
          padding: 0 6px;
          border: 1px solid var(--tf-border-strong);
          border-radius: 9px;
          background: var(--tf-bg);
          color: var(--tf-text);
          font-size: 12.5px;
          font-weight: 600;
          text-align: center;

          &:focus {
            border-color: var(--tf-primary);
            box-shadow: 0 0 0 3px var(--tf-primary-soft);
          }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type=number] { -moz-appearance: textfield; }

        img {
          cursor: pointer;
          height: 10px;
          margin-left: 5px;
        }
      }

      .right-header {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        justify-content: flex-end;

        @media screen and (max-width: 575px) {
          button.action { padding: 0 10px; }
        }
      }
    }

    /* раскрывающиеся таблицы игроков и матчей */
    .body {
      .matches-data, .players-data {
        width: 100% !important;
        margin-top: 12px;
        border: 1px solid var(--tf-border);
        border-radius: 10px;
        overflow: hidden;

        @media screen and (max-width: 500px) { overflow-x: auto; }

        h4 {
          margin: 0;
          padding: 9px 12px;
          background: var(--tf-soft);
          border-bottom: 1px solid var(--tf-border);
          font-size: 11px;
          font-weight: 600;
          letter-spacing: .05em;
          text-transform: uppercase;
          color: var(--tf-muted);
          text-align: left;
        }

        table {
          width: 100%;

          td {
            padding: 8px 12px;
            font-size: 12.5px;
            color: var(--tf-text);
          }

          & > tr:first-child td {
            font-size: 11px;
            font-weight: 600;
            letter-spacing: .04em;
            text-transform: uppercase;
            color: var(--tf-muted);
          }

          & > tr:not(:last-child) { border-bottom: 1px solid var(--tf-border); }

          & > tr:not(:first-child):hover { background: var(--tf-soft); }

          & > tr > td:not(:first-child) { text-align: center; }
        }
      }

      .players-data .player {
        font-size: 13px;
        padding: 9px 12px;
        width: 100%;
      }

      .pug {
        text-align: center;
        margin: 0;
        padding: 14px;
        color: var(--tf-muted);
        font-size: 12.5px;
      }
    }

    /* разделитель между шапкой и строкой с очками */
    .main-data {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      margin-top: 12px;
      padding-top: 12px;
      border-top: 1px solid var(--tf-border);
    }

    /* статус участия — чипом, а не заголовком */
    .status {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: 10px;
      padding: 4px 11px;
      border: 1px solid transparent;
      border-radius: 999px;
      background: var(--tf-soft);

      .status-icon { width: 12px; opacity: .85; }

      .status-text {
        margin: 0;
        font-size: 11.5px;
        font-weight: 700;
        line-height: 18px;
      }

      &--warn {
        background: var(--tf-warn-soft);
        border-color: rgba(240, 160, 32, .35);

        .status-text { color: #a96a0c; }
      }

      &--danger {
        background: var(--tf-danger-soft);
        border-color: rgba(224, 65, 79, .35);

        .status-text { color: var(--tf-danger); }
      }

      &--ok {
        background: var(--tf-ok-soft);
        border-color: rgba(47, 179, 68, .35);

        .status-text { color: #1f8a30; }
      }
    }

    .actions-boards {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }

    /* киллы / место / сумма */
    .activity-board {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;

      .activity {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 5px 11px;
        border: 1px solid var(--tf-border);
        border-radius: 9px;
        background: var(--tf-soft);

        img { width: 12px; height: 12px; opacity: .8; }

        span {
          display: block;
          font-size: 13.5px;
          font-weight: 700;
          color: var(--tf-text-strong);
        }
      }
    }
  }

  footer { margin-left: 0 !important; }
}

body.dark-only .team-card-wrapper {
  @include tf-tokens-dark;
}
</style>